var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.trades.length > 0)?_c('v-chart',{attrs:{"options":_vm.hourlyChartOptions,"autoresize":"","theme":_vm.getChartTheme}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }